import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router";

const saved = new Map<string, number>();
const scroller = () => document.querySelector<HTMLElement>(".pn-app > .pn-main");

/**
 * Where a screen kept in the address's query (a product's Assets, a part of its profile) is scrolled to.
 * Why: the shell keeps a screen's place only when the path changes; these screens share their page's path,
 * so a new one opens at its top and going back returns to where the last one was left.
 */
export function useQueryScreenScroll(screen: string): void {
  const { key } = useLocation();
  const type = useNavigationType();
  const current = useRef(key);
  const shown = useRef(screen);

  useEffect(() => {
    const el = scroller();
    if (!el) return;
    const keep = () => saved.set(current.current, el.scrollTop);
    el.addEventListener("scroll", keep, { passive: true });
    return () => el.removeEventListener("scroll", keep);
  }, []);

  useLayoutEffect(() => {
    current.current = key;
    if (shown.current === screen) return;
    shown.current = screen;
    const el = scroller();
    if (el) el.scrollTop = type === "POP" ? (saved.get(key) ?? 0) : 0;
  }, [key, screen, type]);
}
